import { Box, Button, Card, CardContent, Stack, Typography, Alert } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

import { useAuth } from './AuthContext';

export function LoginPage() {
    const { signInWithGoogle, user, isAdmin, isLoading } = useAuth();

    const isLoggedInButNotAdmin = !isLoading && user && !isAdmin;

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
                background: 'linear-gradient(135deg, #1976d2 0%, #115293 100%)',
            }}
        >
            <Card sx={{ maxWidth: 420, width: '100%' }}>
                <CardContent>
                    <Stack spacing={3} alignItems="center">
                        <Typography variant="h5" component="h1" fontWeight={600}>
                            Unicnet Admin
                        </Typography>
                        <Typography variant="body2" color="text.secondary" textAlign="center">
                            Pieslēdzies ar savu Google kontu. Piekļuve atļauta tikai administratoriem.
                        </Typography>

                        {isLoggedInButNotAdmin && (
                            <Alert severity="warning" sx={{ width: '100%' }}>
                                Tu esi pieslēdzies kā <strong>{user?.email}</strong>, bet šim
                                kontam nav admin tiesību. Sazinies ar projektu administratoru.
                            </Alert>
                        )}

                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<GoogleIcon />}
                            onClick={signInWithGoogle}
                            disabled={isLoading}
                            fullWidth
                        >
                            Pieslēgties ar Google
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}
